  tinymce.PluginManager.add('whatsapp_format', function(editor, url) {
    function applyFormat(wrapper) {
      if (!editor.hasEditableRoot()) return;

      var selectedText = editor.selection.getContent({format: 'text'});
      if (selectedText) {
        editor.selection.setContent(wrapper + selectedText + wrapper);
      } else {
        editor.insertContent(wrapper + wrapper);
        editor.selection.setCursorLocation(editor.selection.getNode(), 1);
      }
    }

    editor.ui.registry.addButton('bold_whatsapp', {
        icon: 'bold',
        onAction: function() {
            applyFormat('*');
        },
        enabled: editor.hasEditableRoot(),
        tooltip: 'Bold (WhatsApp style)'
    });

    editor.ui.registry.addButton('italic_whatsapp', {
        icon: 'italic',
        onAction: function() {
            applyFormat('_');
        },
        enabled: editor.hasEditableRoot(),
        tooltip: 'Italic (WhatsApp style)'
    });

    editor.ui.registry.addButton('strikethrough_whatsapp', {
        icon: 'strike-through',
        onAction: function() {
            applyFormat('~');
        },
        enabled: editor.hasEditableRoot(),
        tooltip: 'Strikethrough (WhatsApp style)'
    });

    editor.ui.registry.addButton('monospace_whatsapp', {
        icon: 'code-sample', // Using the code icon as a placeholder
        onAction: function() {
            applyFormat('```');
        },
        enabled: editor.hasEditableRoot(),
        tooltip: 'Monospace (WhatsApp style)'
    });
  });
